<h2 class="titleDel" mat-dialog-title>{{'MAPP-VMS-CHECK-OUT.TITLE' | translate}}</h2>
<mat-dialog-content class="deleteVisitDialog">
    {{'MAPP-VMS-CHECK-OUT.MESSAGE' | translate}}
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="deleteVisitButton" mat-button (click)="close()">{{'MAPP-VMS-CHECK-OUT.CANCEL' | translate}}</button>
    <button class="deleteVisitButton" mat-button (click)="doCheckOut()">{{'MAPP-VMS-CHECK-OUT.OK' | translate}}</button>
</mat-dialog-actions>
<empusa-mat-spinner-overlay *ngIf="loading" overlay="true"></empusa-mat-spinner-overlay>
